import { SET_SYSTEM } from './types';

export default function globalReducer(state, action) {
  switch (action.type) {
    default:
      return state;
  }
}
